import { useContext, useCallback } from 'react';

import uniq from 'lodash/uniq';

import { MultiSelect } from '@gogame/components';
import { FormContext } from '@gogame/form';
import { usePrevious } from '@gogame/hooks-ts';
import { useQuery } from '@gogame/query';

import {
  loadRoles,
  loadRolePermissions,
} from 'scenes/Users/AdminUsers/sources/fields';

import { ROLE, PERMISSIONS } from '../constants';

export default ({ setLoading }) => {
  const { values, setValues } = useContext(FormContext);

  const { data, isLoading } = useQuery(ROLE, loadRoles);

  const prevPermissions = usePrevious(values[PERMISSIONS]);
  const prevRole = usePrevious(values[ROLE]);

  const handleChange = useCallback(
    async (_, nextRoles) => {
      setLoading(true);
      const {
        actions: prevActions = [],
        pages: prevPages = [],
        ...otherPrevPermissions
      } = prevPermissions || {};
      const oldRoles = prevRole || [];

      const [prevRolePermissions, nextRolePermissions] = await Promise.all([
        Promise.all(
          oldRoles.map((value) => loadRolePermissions({ id: value }))
        ),
        Promise.all(
          nextRoles.map((value) => loadRolePermissions({ id: value }))
        ),
      ]);

      const nextActions = uniq([
        ...prevActions.filter(
          (value) =>
            !prevRolePermissions.some(({ actionIds }) =>
              actionIds.includes(value)
            )
        ),
        ...nextRolePermissions.reduce(
          (result, { actionIds }) => [...result, ...actionIds],
          []
        ),
      ]);
      const nextPages = uniq([
        ...prevPages.filter(
          (value) =>
            !prevRolePermissions.some(({ pageIds }) => pageIds.includes(value))
        ),
        ...nextRolePermissions.reduce(
          (result, { pageIds }) => [...result, ...pageIds],
          []
        ),
      ]);

      const nextPermissions = {
        ...otherPrevPermissions,
        actions: nextActions,
        pages: nextPages,
      };

      setValues({
        ...values,
        [PERMISSIONS]: nextPermissions,
        [ROLE]: nextRoles,
      });
      setLoading(false);
    },
    [setLoading, prevRole, prevPermissions]
  );

  return (
    <MultiSelect
      name={ROLE}
      label={'Role'}
      value={values[ROLE]}
      options={data}
      loading={isLoading}
      onChange={handleChange}
      padding={0}
    />
  );
};
